import React from 'react';
import styled from 'styled-components/macro';
import { withEntityContext } from 'context/entityContext';

function getCompareColor(compareColors: string[], index: number): string {
  return index !== undefined ? compareColors[index] : 'none';
}

const CompareBullet = styled('div')<any>`
  border: 2px solid white;
  width: 0.875em;
  height: 0.875em;
  border-radius: 50%;
  background-color: ${({ index, compareColors }: any): string =>
    getCompareColor(compareColors, index)};
  flex-shrink: 0;
`;

/** @component */
export default withEntityContext(
  ({ dataColors, index, className }: any): any => (
    <CompareBullet
      compareColors={dataColors}
      index={index}
      className={className}
      data-pw="compare-bullet"
      data-color={getCompareColor(dataColors, index)}
    />
  )
);
